<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      岗头站<br>
站点介绍<br>
岗头站位于深圳市龙岗区坂雪岗大道下方，车站主体呈南北走向，南接华为站，北接雪象站。 岗头站色彩基调以白色和蓝色为主，为地下二层车站，地下一层为站厅层，地下二层为站台层，站台形式为岛式站台。车站设置有6个出入口，临近深圳市公安局交通警察支队坂田中队、布吉公交派出所、深圳大学师范学院附属坂田学校，周边以商业广场及住宅区为主。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福田口岸	06:00	23:23	10号线	3分40秒	6分钟<br>
双拥街	06:45	23:32	10号线	3分40秒	6分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福田口岸	06:06	23:23	10号线	4分50秒	7分钟<br>
双拥街	06:53	23:32	10号线	4分50秒	7分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福田口岸	06:01	00:23	10号线	4分50秒	7分钟<br>
双拥街	06:45	00:32	10号线	4分50秒	7分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
坂雪岗大道东侧<br><br>
B出入口:<br>
环城北路南侧（东）<br><br>
C1出入口:<br>
环城北路北侧、深圳市龙岗区行政服务大厅天安云谷分中心、中国·深圳人力资源服务智慧广场、龙岗区图书馆天安云谷分馆<br><br>
C2出入口:<br>
环城北路南侧（西）<br><br>
D出入口:<br>
坂雪岗大道西侧（北）、深圳市公安局交通警察支队坂田中队,宝岗派出所<br><br>
E出入口:<br>
坂雪岗大道西侧（南）<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 城市山海云汇<br>
B604、M267、M272、M346、M521、M572<br><br>
C1出入口:<br>
公交站名： 坂田交警中队<br>
334、624、M545、M543、M267、M272、M281、M309、M346、M383、M461、M491、M525、高快巴士81号、M198、882、M584、B604、M572、E27、M292、高峰专线221（原M221）、高峰专线126号<br><br>
C2出入口:<br>
公交站名： 坂田交警中队<br>
334、624、高快巴士34、M298、M538、M545、M543、M572、M523、E27、E8、M267、M272、M281、M309、M346、M383、M461、M491、M525、高快巴士81号、M198、B604、882、M584、高峰专线221（原M221）、M292<br><br>
D出入口:<br>
公交站名： 岗头地铁站<br>
M309、M521、高峰专线221（原M221）、高峰专线34<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shihaoxian",
            title: "10号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>